import React, { ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useSelectedCommunity from '../hooks/community/useSelectedCommunity';

export default function SelectedCommunityRoute(): ReactElement {
  const community = useSelectedCommunity();
  if (!community || !community.dashboard) return <Navigate to="/" />;
  return <Outlet />;
}
